import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientContactsApiAdapter, UpdateTeamContactRequest } from '../adapters/ClientContactsApiAdapter';

export const useUpdateTeamContact = (teamId: number) => {
    const queryClient = useQueryClient();

    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientContactsApiAdapter(httpClient);
    }, []);

    const mutation = useMutation({
        mutationFn: ({ contactId, data }: { contactId: number; data: UpdateTeamContactRequest }) =>
            apiAdapter.updateContact(teamId, contactId, data),
        onSuccess: () => {
            // Invalidar la cache de contactos para refrescar los datos
            queryClient.invalidateQueries({ queryKey: ['team-contacts', teamId] });
            // También invalidar la cache del cliente por si acaso
            queryClient.invalidateQueries({ queryKey: ['client', teamId] });
        },
    });

    return {
        updateContact: mutation.mutate,
        updateContactAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        reset: mutation.reset,
    };
};

